import React, { useCallback } from "react";

import { Box, Link, Typography } from "@mui/joy";

import FragmentNodePreviewImage from "../FragmentNodePreviewImage";
import { ApiFragmentNode } from "../../shared/interfaces";
import { useParams } from "react-router-dom";
import { OpenInNewOutlined } from "@mui/icons-material";
import { NodeTitle } from "./NodeTitle";

const styles = {
    relatedItemContainer: {
        margin: 1,
        display: "flex",
        flexDirection: "column",
    },
    relatedItemFilename: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        flex: "0 0 auto",
        marginBottom: 1,
    },
    previewContainer: {
        flex: 1,
        overflow: "hidden",
    },
};

export default function RelatedFragmentNode({
    node,
    setFragmentNode,
}: {
    node: ApiFragmentNode;
    setFragmentNode?: (node: ApiFragmentNode | null) => void;
}) {
    const { id = "" } = useParams();

    const sameFile = id === node.fileId;
    const handleSetFragmentNode = useCallback(
        (node: ApiFragmentNode) => (e: React.MouseEvent<HTMLAnchorElement>) => {
            if (sameFile && setFragmentNode) {
                e.preventDefault();
                setFragmentNode(node);
            }
        },
        [setFragmentNode, sameFile],
    );

    const url = `/doc/${node.fileId}/${node.id}`;
    return (
        <Link
            href={url}
            onClick={handleSetFragmentNode(node)}
            target="_blank"
            color="neutral"
            variant="plain"
        >
            <Box sx={styles.relatedItemContainer}>
                <Typography
                    level="title-sm"
                    sx={styles.relatedItemFilename}
                    endDecorator={!sameFile && <OpenInNewOutlined />}
                >
                    <NodeTitle node={node} />
                </Typography>

                <Box sx={styles.previewContainer}>
                    <FragmentNodePreviewImage node={node} />
                </Box>
            </Box>
        </Link>
    );
}
